<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
			
			<div class="kpBox">
				<div class="pageAnniuBox f-bct">
					<div class="l f-ct">
						<el-input type="text" v-model="keword" placeholder="请输入姓名进行查询"></el-input>
						<div class="anniu" @click="membermemberList(1)">搜索</div>
					</div>
					<div class="r f-ct">
						<div class="t1">课程：{{pageMsg.name}}</div>
						<div class="txt">已选成员：<span>{{selList.length}}</span></div>
						<div class="def b1" @click="goSubmit">立即报名</div>
					</div>
				</div>
				<div class="zw" v-if="!kpxxList.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="kfpTable" v-if="kpxxList.length">
					<div class="th f-ct">
						<div class="t1" @click="selFALL">
							<el-image v-if="isSelSel" :src="require('@/static/icon61.png')"></el-image>
							<el-image v-else :src="require('@/static/icon60.png')"></el-image>
							全选
						</div>
						<div class="t2">序号</div>
						<div class="t3">姓名</div>
						<div class="t4">性别</div>
						<div class="t5">身份证号码</div>
						<div class="t8">用户状态</div>
						<div class="t7">申报表</div>
						<div class="t6">联系方式</div>
					</div>
					<div class="td f-ct" v-for="(item,index) in kpxxList">
						<div class="t1" v-if="!item.isAppliedCourse" @click="selF(item)">
							<el-image v-if="item.isHave" :src="require('@/static/icon61.png')"></el-image>
							<el-image v-else :src="require('@/static/icon60.png')"></el-image>
						</div>
						<div class="t1" v-else>
							<el-image :src="require('@/static/icon84.png')"></el-image>
						</div>
						<!-- <div class="t2">{{item.id}}{{item.manFromAdta}}</div> -->
						<div class="t2">{{item.id}}</div>
						<div class="t3">{{item.name}}</div>
						<div class="t4" v-if="item.gender==0">未知</div>
						<div class="t4" v-if="item.gender==1">男</div>
						<div class="t4" v-if="item.gender==2">女</div>
						<div class="t5">{{item.identityCardCode}}</div>
						
						<div class="t8" v-if="item.auditStatus==0">审核中</div>
						<div class="t8" v-if="item.auditStatus==1">审核通过</div>
						<div class="t8" v-if="item.auditStatus==2">
							<el-tooltip class="item" effect="dark" :content="item.auditInfo+''" placement="top">
							<p style="color: red;">审核不通过</p>
							</el-tooltip>
						</div>
						
						<div class="t7 blue" @click="goSubmitMan(item)">填写申报表</div>
						<div class="t6">{{item.companyMobile}}</div>
					</div>
				</div>
				<!-- 分页 -->
				<div class="fenye">
				<el-pagination
				background
				hide-on-single-page
				layout="prev, pager, next,jumper"
				@current-change="goPage"
				:page-size="pageSize"
				:total="total">
				</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { membermemberList,
courseOrderorderCreate,
coursedetail
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			keword:'',
			isRecheck:0,
			categoryId:0,
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			kpxxList:[],
			selList:[],
			// 获取回调用户表单
			manFromAdta:'',
			pageMsg:'',
		}
	},
	mounted() {
		// localStorage.removeItem('selList')
		// 获取浏览路径
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		// 获取选择数据
		var selList = localStorage.getItem('selList')
		selList = JSON.parse(selList)
		this.selList = selList||[]
		localStorage.removeItem('selList')
		// 获取回调用户表单
		var manFromAdta = localStorage.getItem('manFromAdta')
		manFromAdta = JSON.parse(manFromAdta)
		this.manFromAdta = manFromAdta
		this.manFromAdtaF()
		var selList = localStorage.getItem('manFromAdta')
		// 参数
		this.id = this.$route.query.id
		this.isRecheck = this.$route.query.isRecheck*1||0
		this.categoryId = this.$route.query.categoryId*1||0
		// 数据
		this.membermemberList(1)
		this.coursedetail()
	},
	computed:{
		// 是否全选
		isSelSel(){
			var isall = true
			this.kpxxList.forEach((i)=>{
				var isHave = false
				this.selList.forEach((j)=>{
					if(i.id==j.id){
						isHave=true
					}
				})
				if(!isHave){
					isall =false
				}
			})
			return isall
		},
		...mapState('userMsg',['userInfo']),
	},
	methods:{
		// 课程详情
		async coursedetail(){
			let res = await coursedetail({id:this.$route.query.id});
			if(res.code==200){
				this.pageMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 提交
		async goSubmit(){
			var applyList = []
			var isok = true
			if(!this.selList.length){
				this.Tips('请先选择人员','error')
				return
			}
			for(var i in this.selList){
				if(this.selList[i].isHave){
					if(!this.selList[i].isAppliedCourse){
						if(this.selList[i].manFromAdta){
							applyList.push(this.selList[i].manFromAdta)
						}else{
							this.Tips(this.selList[i].name+'暂未填写申报表,请填写后再提交','error')
							isok = false
							return
						}
					}
				}
			}
			if(!isok){
				return
			}
			var data = {
				applyList,
				courseId:this.id,
			}
			const res = await courseOrderorderCreate(data);
			if(res.code==200){
				this.link('/userCoursePay',{id:res.data.id})
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转填数据
		goSubmitMan(item){
			localStorage.setItem("selList", JSON.stringify(this.selList));
			this.link('/qyClassManFrom',{id:item.id,isRecheck:this.isRecheck,categoryId:this.categoryId})
		},
		// 数据填入
		manFromAdtaF(){
			if(!this.manFromAdta){return}
			this.selList.forEach((i,idx)=>{
				if(i.id==this.manFromAdta.memberId){
					i.manFromAdta = this.manFromAdta
				}
			})
			// console.log(this.manFromAdta) 
			// console.log(this.selList)
		},
		// 单选
		selF(item){
			var selList = []
			var isHave = false
			var isHaveIdx = 0
			this.selList.forEach((i,idx)=>{
				selList.push(i)
				if(i.id==item.id){
					isHave=true
					isHaveIdx=idx
				}
			})
			if(isHave){
				selList.splice(isHaveIdx,1)
			}else{
				selList.push(item)
			}
			this.selList = selList
			this.isSel()
		},
		// 全选
		selFALL(){
			this.kpxxList.forEach((i)=>{
				this.selF(i)
			})
		},
		// 判断是否选择
		isSel(){
			this.kpxxList.forEach((i)=>{
				var isHave = false
				this.selList.forEach((j)=>{
					if(i.id==j.id){
						isHave=true
					}
				})
				i.isHave = isHave
			})
		},
		// 获取企业员工列表 列表
		async membermemberList(def){
			if(def){this.pageNum = 1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				courseId:this.id,
			}
			if(this.keword){
				data.name = this.keword
			}
			const res = await membermemberList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.kpxxList = res.rows
				this.isSel()
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.membermemberList()
		},
	},
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding: 0 24px;
	padding-bottom: 40px;
	padding-top: 24px;
}
.kpBox{
	.pageAnniuBox{
		.l{
			.el-input{
				width: 288px;
				height: 46px;
				margin-right: 16px;
			}
			::v-deep .el-input__inner{
				width: 288px;
				height: 46px;
				padding: 0 10px;
				border: 2px solid #E8EDF4;
				background: transparent;
			}
			.anniu{
				width: 85px;
				height: 46px;
				border-radius: 6px;
				text-align: center;
				line-height: 46px;
				font-size: 16px;
				// padding: 0 26px;
				margin-right: 24px;
				cursor: pointer;
				background: #3B6492;
				color: #fff;
			}
		}
		.r{
			.t1{
				color: #454A53;
				font-size: 18px;
				font-weight: bold;
				padding-right: 26px;
			}
			.txt{
				color: #454A53;
				font-size: 14px;
				padding-right: 16px;
				span{
					color: #3B6492;
				}
			}
			.def{
				width: 148px;
				height: 46px;
				border-radius: 6px;
				text-align: center;
				line-height: 46px;
				font-size: 16px;
				padding: 0 26px;
				margin-right: 24px;
				cursor: pointer;
			}
			.b2{
				background: #E9F6FF;
				color: #3B6492;
			}
			.b1{
				background: #3B6492;
				color: #fff;
			}
		}
	}
	.kfpTable{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		margin-top: 24px;
		// margin-bottom: 40px;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			div{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.t1{
				width: 100px;
				.el-image{
					width: 20px;
					height: 20px;
					margin-right: 6px;
				}
			}
			.t2{
				width: 200px;
			}
			.t3{
				width: 148px;
			}
			.t4{
				width: 206px;
			}
			.t5{
				width: 302px;
			}
			.t6{
				width: 202px;
			}
			.t7{
				width: 180px;
			}
			.t8{
				width: 180px;
			}
			.blue{
				color: #3B6492;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				line-height: 26px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 16px 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 100px;
				.el-image{
					width: 20px;
					height: 20px;
				}
			}
			.t2{
				width: 200px;
			}
			.t3{
				width: 148px;
			}
			.t4{
				width: 206px;
			}
			.t5{
				width: 302px;
			}
			.t6{
				width: 202px;
			}
			.t7{
				width: 180px;
			}
			.t8{
				width: 180px;
			}
			.blue{
				color: #3B6492;
				cursor: pointer;
			}
		}
	}
}
.fenye{
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 26px;
	padding-right: 24px;
	.i1{
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
	.fyitm{
		width: 32px;
		height: 32px;
		font-size: 12px;
		text-align: center;
		line-height: 32px;
		margin-right: 6px;
		border-radius: 4px;
	}
	.a{
		background: #3B6492;
		color: #fff;
	}
	.i2{
		width: 24px;
		height: 24px;
		margin-right: 19px;
	}
	.linkPage{
		p{
			font-size: 12px;
		}
		.ipt{
			margin: 0 6px;
			width: 42px;
			height: 32px;
			border-radius: 4px;
			background: #F4F4F4;
			.el-select{
				width: 100%;
			}
			::v-deep .el-input__inner{
				border: none;
				background: transparent;
			}
		}
	}
}
</style>